import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IS_EXPORT_ENV } from '../../../src/constants';
import Layout from '~/src/layout/_layout';
import RestorePassword from '../../../src/layout/restorePassword';
import * as base from '~/src/helpers/basePageFunc';

class RestorePasswordPage extends Component {

    static propTypes = {
        city: PropTypes.object,
        hostname: PropTypes.string,
    };

    static async getInitialProps(options) {
        const { hostname } = await base.initialProps(options);
        return { hostname };
    }

    render() {
        const { city, hostname } = this.props;
        const clientHostname = IS_EXPORT_ENV && process.browser ? document.location.hostname : hostname;
        const link = `https://${city.domain}.dom.ru/user/recovery/pass`;

        return (
            <Layout
                title='Восстановление пароля'
                hostname={clientHostname}
                city={city}
                withMenu={true}
                withChat={true}
                relCanonical={link}
            >
                <RestorePassword city={city}/>
            </Layout>
        );
    }
}

const mapStateToProps = (state) => ({
    city: state.city.currentCity
});

export default connect(mapStateToProps)(RestorePasswordPage);
